<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="Title" placeholder="请输入素材标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getMaterialQR">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addCerfityData">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
        </el-form-item>
      </el-form>
    </header>
    <div class="cerfity-form-content">
      <el-table
        ref="multipleeeeTablerz"
        :data="table"
        tooltip-effect="dark"
        empty-text=" "
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" type="selection" width="55"></el-table-column>
        <el-table-column prop="identification" label="标识"></el-table-column>
        <el-table-column prop="description" label="说明" ></el-table-column>
        <el-table-column prop="SourceUrl" label="资源Url"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div>
              <el-button
                type="primary"
                @click="editCerfity(scope.row.id,scope.row.sourceTitle,scope.row.SourceUrl,scope.row.description,scope.row.identification)"
                size="mini"
              >编辑</el-button>
              <el-button type="primary" size="mini" @click="seeCode(scope.row.url)">查看</el-button>
              <el-button type="danger" @click="deleteCerfity(scope.row.id)" size="mini">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="u-page-con">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="标题" prop="title">
            <el-input v-model="ruleForm.SourceTitle"></el-input>
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="ruleForm.SourceUrl"></el-input>
          </el-form-item>
          <el-form-item label="标识">
            <el-input v-model="ruleForm.Identification"></el-input>
          </el-form-item>
          <el-form-item label="说明">
            <el-input v-model="ruleForm.Description"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="QR"
      width="600px"
      :append-to-body="true"
    >
      <qrcode-vue :value="value" size="500" level="H" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="QR = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  data() {
    return {
      dialogTitle: "",
      ruleForm: {
        materialQRId: "",
        SourceUrl: "",
        SourceTitle: "",
        Description: "",
        Identification: ""
      },
      rules: {
        SourceTitle: [
          { required: true, message: "请输入标题", trigger: "blur" }
        ],
        SourceUrl: [{ required: true, message: "请输入地址", trigger: "blur" }],
        Description: [
          { required: true, message: "请输入说明", trigger: "blur" }
        ],
        Identification: [
          { required: true, message: "请输入标识", trigger: "blur" }
        ]
      },
      urlAliyunOSS: "/api/design/osssign/getsign",
      table: [],
      dialogVisible: false,
      logoUrl: "",
      defaultCerfityImg: require("assets/images/bg4.png"),
      total: 0,
      pageSize: 5,
      pageIndex: 1,
      Ids: [],
      Title: "",
      QR: false,
      value:"",
    };
  },
  components: {
    QrcodeVue
  },
  created() {
    this.getMaterialQR();
  },
  methods: {
    handleSelectionChange(val) {
      this.Ids = [];
      val.forEach(element => {
        this.Ids.push(element.id);
      });
      console.log(this.Ids);
    },
    onPageChangeHandler(page) {
      this.pageIndex = page;
      this.getMaterialQR();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMaterialQR(1);
    },
    getMaterialQR(page) {
      let that = this;
      this.$http
        .post("/api/XOrg/StudentManager/getMaterialQR", {
          Title: this.Title,
          page: page,
          pageSize: that.pageSize
        })
        .then(res => {
          if (res.code > 0) {
            that.table = res.list;
            that.total = res.pagination.totalCount;
            that.pageSize = res.pagination.pageSize;
            that.pageIndex = res.pagination.pageIndex;
          }
        });
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http
            .post("/api/XOrg/StudentManager/editOrSaveMaterialQR", {
              materialQRId: this.ruleForm.materialQRId,
              SourceUrl: this.ruleForm.SourceUrl,
              SourceTitle: this.ruleForm.SourceTitle,
              Description: this.ruleForm.Description,
              Identification: this.ruleForm.Identification
            })
            .then(function(rst) {
              if (rst.code > 0) {
                that.getMaterialQR();
                that.dialogVisible = false;
              }
            });
          
        } else {
          return false;
        }
      });
    },
    cancelForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    addCerfityData() {
        this.dialogTitle = "添加素材";
      this.ruleForm.materialQRId = "";
      this.ruleForm.SourceUrl = "";
      this.ruleForm.SourceTitle = "";
      this.ruleForm.Description = "";
      this.ruleForm.Identification = "";
      this.dialogVisible = true;
    },
    editCerfity(id, sourceTitle, SourceUrl, description,identification) {
        this.dialogTitle = "修改素材";
      this.ruleForm.materialQRId = id;
      this.ruleForm.SourceUrl = SourceUrl;
      this.ruleForm.SourceTitle = sourceTitle;
      this.ruleForm.Description = description;
      this.ruleForm.Identification = identification;

      this.dialogVisible = true;
    },
    seeCode(codeUrl){
        // let qrcode = new QRCode('qrcode', {
        //     width: 100,  
        //     height: 100, // 高度  
        //     text: codeUrl // 二维码内容  
        // })

        this.value = codeUrl;

        this.QR = true;
    },
    deleteCerfity(id) {
      this.$confirm("此操作将删除该素材, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let that = this;
          var arr = [];
          arr.push(id);
          this.$http
            .post("/api/XOrg/StudentManager/deleteMaterialQR", {
              materialQRIds: arr
            })
            .then(res => {
              if (res.code > 0) {
                this.getMaterialQR();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    deleteAll() {
      if (this.Ids.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择素材资源",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选的素材, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let that = this;
          this.$http
            .post("/api/XOrg/StudentManager/deleteMaterialQR", {
              materialQRIds: arr
            })
            .then(res => {
              if (res.code > 0) {
                this.getMaterialQR();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>
<style lang="scss">
.wlx-site-manager-wrapper {
  .scope-p {
    max-height: 66px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    img {
      width: auto !important;
      max-height: 50px;
    }
  }
}
.wl-cerfity-standard-wrapper {
  .cerfity-standard-title {
    padding: 20px 0px;
    font-size: 20px;
    font-weight: normal;
    color: #2d82ff;
  }
  .cerfity-form-content {
    .cerfity-img-con {
      height: 50px;
      img {
        max-height: 50px;
      }
    }
  }
}
</style>
